<template>
  <div class="RangeSlider" :class="classes">
    <label class="RangeSlider__label">{{ labelText }}</label>
    <input type="range" min="1" max="100" value="50" ref="sliderInput" id="sliderInput" class="RangeSlider__input">
    <div class="RangeSlider__infoText">
      <div class="RangeSlider__low">Light</div>
      <div class="RangeSlider__high">Intense</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'RangeSlider',

    props: {
      theme: {
        type: String,
        default: 'orchard'
      },
      labelText: {
        type: String,
        default: 'Vanilla'
      },
      lowText: {
        type: String,
        default: 'Light'
      },
      highText: {
        type: String,
        default: 'Intense'
      }
    },

    data() {
      return {
        sliderInput: null,
        colours: {
          orchard: '#AF695B, #C09C83, #AF695B',
          smoke: '#8789A9, #A5B0E3, #8789A9',
          chard: '#DCB26C, #F4BC89, #9A6D41'
        }
      }
    },

    mounted() {
      this.bindRangeSlider()
      //if (this.theme) {
        this.setDefaultGradient()
      //}
    },

    computed: {
      classes() {
        return {
          [`RangeSlider--theme--${this.theme}`]: this.theme
        }
      }
    },
    methods: {
      setDefaultGradient() {
        const x = 50
        const remainingPercentage = 50
        let color = `linear-gradient(to right, ${this.colours[this.theme]} ${x}%, #000000 ${remainingPercentage}%)`;
        // If start of slider range background just needs to be black (no gradient)
        if (x === 1 ) {
          color = '#000000'
        }
        this.sliderInput.style.background = color;
      },
      bindRangeSlider() {
        this.sliderInput = this.$refs.sliderInput
        this.sliderInput.addEventListener('input', () => {
          let x = parseInt(this.sliderInput.value);
          let remainingPercentage = this.sliderInput.value;
          // UI trick to keep the slider behind diamond icon at all times:
          if (x > 75 ) {
            x -= 7
          }
          let color = `linear-gradient(to right, ${this.colours[this.theme]} ${x}%, #000000 ${remainingPercentage}%)`;
          // If start of slider range background just needs to be black (no gradient)
          if (x === 1 ) {
            color = '#000000'
          }
          this.sliderInput.style.background = color;

          // formatting number: changing 1-100 range to 1-5
          // don't want to to change on input because 1-100 range means the slider is smoother
          const formatNumber = Math.round(x / 20)
          // Set min value so 0 cannot be set
          this.$emit('input', Math.max(1, formatNumber))
        });
      }
    }
  }
</script>

<style lang="scss">
  @import '../scss/variables.scss';
  @import '../scss/mixins.scss';

  .RangeSlider {
    $RangeSliderIconWidth: 34px;
    $RangeSliderIconHeight: 29px;
    $RangeSliderTransitionSpeed: .2s;
    color: $white;
    font-family: $primary-font;
    width: 100%;

    &__label {
      letter-spacing: 1.5px;
      font-size: 14px;
      text-transform: uppercase;
      text-align: center;
      margin-bottom: 0.938em;
      display: block;
    }

    &__input {
      -webkit-appearance: none;
      appearance: none;
      width: 100%;
      height: 2px;
      border-radius: 16px;
      background-image: $orchard-gradient-to-right;
      margin-bottom: 1.250em;
      outline: none;
      opacity: 1;
      -webkit-transition: $RangeSliderTransitionSpeed;
      transition: opacity $RangeSliderTransitionSpeed;
      &:hover {
        opacity: 1;
      }
      &::-moz-range-thumb {
        background: url('../assets/orchard-slider-icon.svg') no-repeat 0 0;
        width: $RangeSliderIconWidth;
        height: $RangeSliderIconHeight;
        cursor: pointer;
        border: 0;
      }
      &::-webkit-slider-thumb {
        background: url('../assets/orchard-slider-icon.svg') no-repeat 0 0;
        width: $RangeSliderIconWidth;
        height: $RangeSliderIconHeight;
        -webkit-appearance: none;
        appearance: none;
        border: 0;
      }
    }

    &__infoText {
      display: flex;
      justify-content: space-between;
      font-size: 11px;
    }

    // Theme overrides
    &--theme--smoke {
      .RangeSlider__input {
        background-image: $smoke-gradient-to-right;
        &::-moz-range-thumb {
          background: url('../assets/smoke-slider-icon.svg') no-repeat 0 0;
        }
        &::-webkit-slider-thumb {
          background: url('../assets/smoke-slider-icon.svg') no-repeat 0 0;
        }
      }
    }
    &--theme--chard {
      .RangeSlider__input {
        background-image: $chard-gradient-to-right;
        &::-moz-range-thumb {
          background: url('../assets/chard-slider-icon.svg') no-repeat 0 0;
        }
        &::-webkit-slider-thumb {
          background: url('../assets/chard-slider-icon.svg') no-repeat 0 0;
        }
      }
    }

  }
</style>
